module.exports = __webpack_public_path__ + "static/media/Welcome.71c5f642.svg";